export default __webpack_public_path__ + "static/media/katbooklogo.1892aca2.png";